import React from "react";
import style from "./Fields.module.scss";
import Autosuggest from "../../../Autosuggest/Autosuggest";
import { Field } from "../../Order/Field/Field";
import { PersonType, getPersonTypeName } from "./types";

const Account = ({ type, value, error, disabled, onChange, fetchs }) => {
  const fetchSearch = ({ value }) => {
    return new Promise((resolve) => {
      if (type == PersonType.All) {
        fetchs.accounts(
          {
            length: 10,
            text: value,
          },
          (response) => {
            resolve(
              response.accounts.map((a) => {
                const accountAttrs = JSON.parse(a.Value);

                return {
                  id: a.Id,
                  name: accountAttrs.value,
                  number: accountAttrs.key,
                };
              })
            );
          }
        );
      } else {
        fetchs.persons(
          {
            SdtPersonSearch: {
              len: 10,
              personType: type,
              text: value,
            },
          },
          (response) => {
            resolve(
              response.SdtOutPersons.collection.map((a) => {
                return {
                  id: a.PersonId,
                  name: a.PersonLegalName,
                };
              })
            );
          }
        );
      }
    });
  };

  const internalOnChange = (method, value) => {
    let _value = {
      id: null,
      name: "",
      number: null,
    };

    if (method != "type" && value.id) {
      _value = { ...value };
    }

    onChange(_value);
  };

  return (
    <Field label={getPersonTypeName(type)} error={error}>
      <Autosuggest
        renderSuggestion={(suggestion) => (
          <div className={style.suggestionItem}>
            <span>{suggestion.name}</span>
          </div>
        )}
        getSuggestionValue={(s) => `${s.name}`}
        onSuggestionsFetchRequested={fetchSearch}
        value={value || ""}
        inputProps={{
          placeholder: getPersonTypeName(type),
          invalid: !!error,
          disabled,
        }}
        onChange={(m, v) => internalOnChange(m, v)}
      />
    </Field>
  );
};

export default Account;
